/**************************************************
 * Nombre:       Formulario_Contacto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AccountCircleOutlined, AndroidOutlined, MailOutline} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import {PAISESINDICATIVO} from "../../Modulo_formularios/Recursos/indicativos";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";
import {obtenerIndicativo} from "../../Modulo_formularios/Funciones/obtenerIndicativo";

const Formulario_Contacto = ({...props}) => {

    const setIndicativo = (val) => {

        if (!val) return

        let indicativo = obtenerIndicativo(val)
        props.props.setValue('indicativo', indicativo)
    }

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'felx-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelectFuncion Icono={AndroidOutlined} nombre={'Pais'} dato={'pais'} {...props}
                                          opciones={PAISESINDICATIVO.map((it) => it.nameES)} setDato={setIndicativo}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={AndroidOutlined} nombre={'Celular'} dato={'celular'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={6} Icono={AndroidOutlined} nombre={'Mensaje (opcional)'}
                                  dato={'mensaje'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Contacto